export default Object.freeze({
  openId: 'openId',
  tenantId: 'tenantId',
  privacyAgreed: 'privacyAgreed',
  code: 'code',
  token: 'token',
  bindState: 'bindState',
});
